export const dashboardFormFieldHook = 'dashboard-form-field';
export const dashboardInputHook = 'dashboard-input-lean';
